const usersData = 
[      
  {
    concept:'Placa de identificación con QR', 
    price_und: '59.900', 
    price: '49.900',   
  },             
];
    
    export default usersData